import { Color, Md } from "@client";
import { css } from "@emotion/css";
import { TSubGameList } from "@share";
import { subViewList } from "@sub";
import { Checkbox, Col, Popover, Row } from "antd";
import React from "react";

export function Process(props: { subGameList: TSubGameList }) {
  const lastRoundSubGameMap = props.subGameList.reduce((subGameMap, item) => {
      const { namespace, r } = item;
      if (!subGameMap.has(namespace) || r > subGameMap.get(namespace).r) {
        subGameMap.set(namespace, item);
      }
      return subGameMap;
    }, new Map<string, TSubGameList[0]>()),
    lastRoundSubGameList = [...lastRoundSubGameMap.values()];
  return (
    <Popover
      placement="bottom"
      content={
        <Row style={{ maxWidth: Md.fnWidth }}>
          {lastRoundSubGameList.map(({ namespace, over }) => (
            <Col
              key={namespace}
              className={css`
                flex-basis: 25%;
                padding: 0.5rem 0;
              `}
            >
              <Checkbox checked={over}>{subViewList.find((s) => s.namespace === namespace).label}</Checkbox>
            </Col>
          ))}
        </Row>
      }
      className={css`
        color: ${Color.light};
        font-size: 2rem;
        text-align: center;
        cursor: pointer;
      `}
    >
      实验进度
      <span
        className={css`
          font-size: 1.5rem;
        `}
      >
        &nbsp;({lastRoundSubGameList.filter(({ over }) => over).length}/{lastRoundSubGameList.length})
      </span>
    </Popover>
  );
}
